import { SyntheticEvent } from 'react';

export interface ActionsViewProps {
  activeTab: ActionsTabs;
  onChangeTab: (_: SyntheticEvent, value: ActionsTabs) => void;
  isOpenChat: boolean;
}

export enum ActionsTabs {
  Emojis = 'emojis',
  Reactions = 'reactions',
}
